import Constants from '../actions/types';

const initialState = {
  jobEntries: [],
  loading: false,
  error: null
};

const adjustValues = value => {
  let date = `${value.dateCreated}`;
  value.dateCreated = date.substring(0, date.indexOf('.'));
  date = `${value.dateStarted}`;
  value.dateStarted = date.substring(0, date.indexOf('.'));
  date = `${value.dateCompleted}`;
  value.dateCompleted = date.substring(0, date.indexOf('.'));
  value.jobTypeName = value.jobType.jobTypeName;
  return value;
};

const jobEntriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.JOBENTRIES_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.JOBENTRIES_GET_SUCCESS: {
      const data = action.payload.map(value => adjustValues(value));
      const newState = {
        ...state,
        jobEntries: data,
        loading: false
      };

      return newState;
    }

    case Constants.JOBENTRIES_GET_FAILURE: {
      const newState = {
        ...state,
        jobEntries: [],
        error: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.JOBENTRIES_DELETE_SUCCESS: {
      const selectedJob = state.jobEntries.find(
        entry => entry.jobEntryId === action.payload.jobEntryId
      );
      const index = state.jobEntries.indexOf(selectedJob);
      const newJobEntries = [].concat(
        state.jobEntries.slice(0, index),
        state.jobEntries.slice(index + 1)
      );
      const newState = {
        ...state,
        jobEntries: newJobEntries,
        loading: false
      };

      return newState;
    }

    case Constants.JOBENTRIES_DELETE_FAILURE: {
      const newState = {
        ...state,
        error: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.JOBENTRYEVENTLOGS_GET_SUCCESS: {
      const newState = {
        ...state,
        jobEntryEventLogs: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.JOBENTRYEVENTLOGS_GET_FAILURE: {
      const newState = {
        ...state,
        error: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.JOBENTRIES_CLEAR_ERROR: {
      return { ...state, error: null, loading: false };
    }

    default: {
      return state;
    }
  }
};

export default jobEntriesReducer;
